// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.settings {
  color: #24252f;
  font-size: 30px;
  font-weight: 700;
  line-height: 29px;
  margin-bottom: 30px;
  text-align: left;
  margin-left: 48px;
  padding-top: 20px;
}

.accountInfo {
  padding: 20px 20px;
  margin: 0px 30px;
  background-color: #ffffff;
  border-radius: 7px;
}

.accounttop {
  margin-top: 15px;
  display: flex;
  flex-direction: column;
  gap: 20px;
  flex-wrap: wrap;
}

.accountHeading {
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.infoItem {
  display: flex;
  align-items: center;
  padding-top: 10px;
}

.infoItem p {
  width: 100px;
  text-align: left;
}

.infospan {
  border: 1px solid #dfdfdf;
  padding: 8px;
  width: 80%;
  border-radius: 4px;
  text-align: left;
}

.usernameInput {
  width: 256px;
  background-color: #ffffff;
  border: 1px solid rgb(191, 191, 191);
  border-radius: 7px;
  font-size: 12px;
  line-height: 16px;
  color: rgb(157, 157, 157);
  padding: 10px 0 10px 15px;
}

.changePassword {
  padding: 20px 20px;
  margin: 0px 30px;
  background-color: white;
  /* margin-top: 20px; */
  border-radius: 7px;
}

.passwordInfo {
  padding-top: 15px;
  text-align: left;
  display: flex;
  flex-direction: row;
  gap: 50px;
}

.passwordbuttons {
  display: flex;
  flex-direction: row;
  gap: 10px;
}

.passwordInfo span {
  padding-bottom: 20px;
}

.passwordpara {
  text-align: left;
  padding: 15px 0px;
}

.passwordInfo button {
  font-size: 14px;
  line-height: 18px;
  color: #000000;
  padding: 4px 10px;
  margin: 25px 5px;
  border: 1px solid #6e84a3;
  border-radius: 4px;
  background-color: white;
  cursor: pointer;
}

.dialogDiv {
  /* width: 500px; */
  height: 308px;
  padding: 20px;
  border-radius: 18px;
  background-color: white;
}

.inputdiv {
  position: relative;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 10px 30px 10px 0px;
  width: 100%;
}

.inputdiv label {
  width: 230px;
}

.inputdiv input {
  height: 35px;
  border-radius: 7px;
  padding-left: 10px;
}

.inputdiv svg {
  position: absolute;
}

.buttonpasswordchange {
  cursor: pointer;
}

.buttondiv {
  display: flex;
  justify-content: center;
}

.icon {
  right: 2px;
}

.dialogTop h1 {
  text-align: center;
}`, "",{"version":3,"sources":["webpack://./routes/setting/index.css"],"names":[],"mappings":"AAAA;EACE,cAAA;EACA,eAAA;EACA,gBAAA;EACA,iBAAA;EACA,mBAAA;EACA,gBAAA;EACA,iBAAA;EACA,iBAAA;AACF;;AAEA;EACE,kBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;AACF;;AACA;EACE,gBAAA;EACA,aAAA;EACA,sBAAA;EACA,SAAA;EACA,eAAA;AAEF;;AAAA;EACE,aAAA;EACA,8BAAA;EACA,mBAAA;AAGF;;AAAA;EACE,aAAA;EACA,mBAAA;EACA,iBAAA;AAGF;;AAAA;EACE,YAAA;EACA,gBAAA;AAGF;;AADA;EACE,yBAAA;EACA,YAAA;EACA,UAAA;EACA,kBAAA;EACA,gBAAA;AAIF;;AADA;EACE,YAAA;EACA,yBAAA;EACA,oCAAA;EACA,kBAAA;EACA,eAAA;EACA,iBAAA;EACA,yBAAA;EACA,yBAAA;AAIF;;AAFA;EACE,kBAAA;EACA,gBAAA;EACA,uBAAA;EACA,sBAAA;EACA,kBAAA;AAKF;;AAHA;EACE,iBAAA;EACA,gBAAA;EACA,aAAA;EACA,mBAAA;EACA,SAAA;AAMF;;AAJA;EACE,aAAA;EACA,mBAAA;EACA,SAAA;AAOF;;AALA;EACE,oBAAA;AAQF;;AANA;EACE,gBAAA;EACA,iBAAA;AASF;;AAPA;EACE,eAAA;EACA,iBAAA;EACA,cAAA;EACA,iBAAA;EACA,gBAAA;EACA,yBAAA;EACA,kBAAA;EACA,uBAAA;EACA,eAAA;AAUF;;AARA;EACE,kBAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAWF;;AATA;EACE,kBAAA;EACA,aAAA;EACA,8BAAA;EACA,mBAAA;EACA,2BAAA;EACA,WAAA;AAYF;;AAVA;EACE,YAAA;AAaF;;AAXA;EACE,YAAA;EACA,kBAAA;EACA,kBAAA;AAcF;;AAZA;EACE,kBAAA;AAeF;;AAbA;EACE,eAAA;AAgBF;;AAdA;EACE,aAAA;EACA,uBAAA;AAiBF;;AAdA;EACE,UAAA;AAiBF;;AAdA;EACE,kBAAA;AAiBF","sourcesContent":[".settings {\n  color: #24252f;\n  font-size: 30px;\n  font-weight: 700;\n  line-height: 29px;\n  margin-bottom: 30px;\n  text-align: left;\n  margin-left: 48px;\n  padding-top: 20px;\n}\n\n.accountInfo {\n  padding: 20px 20px;\n  margin: 0px 30px;\n  background-color: #ffffff;\n  border-radius: 7px;\n}\n.accounttop {\n  margin-top: 15px;\n  display: flex;\n  flex-direction: column;\n  gap: 20px;\n  flex-wrap: wrap;\n}\n.accountHeading {\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n}\n\n.infoItem {\n  display: flex;\n  align-items: center;\n  padding-top: 10px;\n}\n\n.infoItem p {\n  width: 100px;\n  text-align: left;\n}\n.infospan {\n  border: 1px solid #dfdfdf;\n  padding: 8px;\n  width: 80%;\n  border-radius: 4px;\n  text-align: left;\n}\n\n.usernameInput {\n  width: 256px;\n  background-color: #ffffff;\n  border: 1px solid rgb(191, 191, 191);\n  border-radius: 7px;\n  font-size: 12px;\n  line-height: 16px;\n  color: rgb(157, 157, 157);\n  padding: 10px 0 10px 15px;\n}\n.changePassword {\n  padding: 20px 20px;\n  margin: 0px 30px;\n  background-color: white;\n  /* margin-top: 20px; */\n  border-radius: 7px;\n}\n.passwordInfo {\n  padding-top: 15px;\n  text-align: left;\n  display: flex;\n  flex-direction: row;\n  gap: 50px;\n}\n.passwordbuttons {\n  display: flex;\n  flex-direction: row;\n  gap: 10px;\n}\n.passwordInfo span {\n  padding-bottom: 20px;\n}\n.passwordpara {\n  text-align: left;\n  padding: 15px 0px;\n}\n.passwordInfo button {\n  font-size: 14px;\n  line-height: 18px;\n  color: #000000;\n  padding: 4px 10px;\n  margin: 25px 5px;\n  border: 1px solid #6e84a3;\n  border-radius: 4px;\n  background-color: white;\n  cursor: pointer;\n}\n.dialogDiv {\n  /* width: 500px; */\n  height: 308px;\n  padding: 20px;\n  border-radius: 18px;\n  background-color: white;\n}\n.inputdiv {\n  position: relative;\n  display: flex;\n  justify-content: space-between;\n  align-items: center;\n  padding: 10px 30px 10px 0px;\n  width: 100%;\n}\n.inputdiv label {\n  width: 230px;\n}\n.inputdiv input {\n  height: 35px;\n  border-radius: 7px;\n  padding-left: 10px;\n}\n.inputdiv svg {\n  position: absolute;\n}\n.buttonpasswordchange {\n  cursor: pointer;\n}\n.buttondiv {\n  display: flex;\n  justify-content: center;\n}\n\n.icon {\n  right: 2px;\n}\n\n.dialogTop h1 {\n  text-align: center;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
